import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    applicationSubmitted: {
        id: '_.application_progress_bar.application_submitted',
        defaultMessage: 'Application submitted'
    },
    documentsReview: {
        id: '_.application_progress_bar.documents_review',
        defaultMessage: 'Documents review'
    },
    creditAnalystReview: {
        id: '_.application_progress_bar.credit_analyst_review',
        defaultMessage: 'Credit analyst review'
    },
    yourDecision: {
        id: '_.application_progress_bar.yourDecision',
        defaultMessage: 'Your decision'
    }
});
